import { useCallback } from "react"
import { useSetState } from "ahooks-v2"
import { createModel } from "hox"
import type { SiteVO, BusinessDistrictVO } from "@/api"
import { SiteChooseWay } from "@/api"
// ==============================================
interface SelectionArgs {
  // 当前模块（SiteChooseWay）
  siteChooseWay: string
  // 选址列表的点
  sitePointList: SiteVO[]
  // 选中的智能选址网点
  activeSitePoint?: SiteVO | null
  // 专家经验-更新凭据
  siteRefreshCount: number
  // 智能推荐-更新凭据
  systemRefreshCount: number
  // 自选推荐-更新凭据
  optionalRefreshCount: number
  // 商圈数据
  businessCircleList: BusinessDistrictVO[]
}
function useSelection() {
  const [state, set] = useSetState<SelectionArgs>({
    siteChooseWay: SiteChooseWay.SYSTEM_RECOMMEND,
    sitePointList: [],
    siteRefreshCount: 0,
    systemRefreshCount: 0,
    optionalRefreshCount: 0,
    businessCircleList: [],
  })
  const setAllState = useCallback(
    (value: Partial<SelectionArgs> | ((prevState: SelectionArgs) => Partial<SelectionArgs>)) => {
      set(value)
    },
    [set],
  )
  return {
    ...state,
    setAllState,
  }
}

export default createModel(useSelection)
